<div class="edit-container">
    <h1 class="edit-title">Închidere proiect</h1>
    <form class="edit-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Garanție</mat-label>
                    <input matInput [matDatepicker]="pickerGarantie" formControlName="garantie" readonly
                        (focus)="pickerGarantie.open()" />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerGarantie"></mat-datepicker-toggle>
                    <mat-datepicker #pickerGarantie></mat-datepicker>
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-error *ngIf="!form.controls['garantie'].valid && form.controls['garantie'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row my-3">
            <div class="col">
                <div clas="p-1 mb-3 fw-bold">Observații:</div>
                <angular-editor formControlName="observatii" [config]="editorConfig"></angular-editor>
                <mat-error *ngIf="!form.controls['observatii'].valid && form.controls['observatii'].touched">
                    Câmp obligatoriu
                </mat-error>
            </div>
        </div>

        <div class="document-upload mb-3">
            <div class="document-upload-header">
                <p class="upload-text">Fotografii/Documente</p>
                <button class="upload-btn" (click)="fileInput.click()" type="button">
                    <mat-icon class="upload-icon me-2">cloud_upload</mat-icon>
                    ÎNCARCĂ
                </button>
            </div>
            <div class="document-upload-files" *ngIf="
                    form.value.files.length > 0 &&
                    !uploading
                ">
                <div class="document-upload-file" *ngFor="
                        let uploadedFile of form.value.files;
                        let i = index
                    ">
                    <span class="document-upload-file-name">
                        {{
                        uploadedFile.original_name.length > 30
                        ? (uploadedFile.original_name | slice : 0 : 30) +
                        ".."
                        : uploadedFile.original_name
                        }}
                    </span>
                    <div>
                        <button class="document-upload-file-delete" type="button" matTooltip="Șterge fișierul încărcat"
                            (click)="removeFile(i)">
                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                        </button>
                    </div>
                </div>
            </div>
            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px" *ngIf="uploading"></mat-spinner>

            <input type="file" accept="image/png, image/jpeg, image/gif, image/jpg, application/pdf"
                id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event, 'file')" multiple
                style="display: none" />
        </div>

        <div class="row">
            <div class="col d-flex justify-content-between">
                <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.cancel }}
                </button>
                <button class="buttons" type="submit" mat-flat-button color="primary" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.confirm }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>